// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-3dc70d7d]{color:#7a0000;text-decoration:none;background-color:rgba(0,0,0,0)}.custom-table td[data-v-3dc70d7d]{padding:0;line-height:35px}", ""]);
// Exports
module.exports = exports;
